import React, { useEffect, useMemo, useRef, useState } from "react";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import { useNavigate } from "react-router-dom";


const flattenMenu = (menu: any[]): any[] => {
    const result: any[] = [];

    const traverse = (items: any[], parent?: string) => {
        items?.forEach((item) => {
            if (item.items) {
                traverse(item.items, item.label);
            } else {
                result.push({
                    label: item.label,
                    to: item.to,
                    icon: item.icon,
                    parent,
                    permission: item.permission,
                });
            }
        });
    };

    traverse(menu);
    return result;
};

const GlobalSearch: React.FC<any> = ({ menu,visible, setVisible }) => {
    // const [visible, setVisible] = useState(false);
    const [query, setQuery] = useState("");
    const [activeIndex, setActiveIndex] = useState(0);
    const navigate = useNavigate();
    const itemRefs = useRef<(HTMLDivElement | null)[]>([]);
    const flatMenu = useMemo(() => flattenMenu(menu), [menu]);
    const results = useMemo(() => {
        let items = flatMenu;
        if (!query) return items;
        return items.filter((item) =>
            item.label.toLowerCase().includes(query.toLowerCase())
        );
    }, [query, flatMenu]);

    useEffect(() => {
        const handler = (e: KeyboardEvent) => {
            if ((e.ctrlKey || e.metaKey) && e.key.toLowerCase() === "k") {
                e.preventDefault();
                setVisible((prev:any) => !prev);
            }
        };

        window.addEventListener("keydown", handler);
        return () => window.removeEventListener("keydown", handler);
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        const handler = (e: KeyboardEvent) => {
            if (!visible) return;

            if (e.key === "ArrowDown") {
                e.preventDefault();
                setActiveIndex((prev) =>
                    prev < results.length - 1 ? prev + 1 : prev
                );
            }

            if (e.key === "ArrowUp") {
                e.preventDefault();
                setActiveIndex((prev) => (prev > 0 ? prev - 1 : 0));
            }

            if (e.key === "Enter") {
                if (results[activeIndex]) {
                    navigate(results[activeIndex].to);
                    setVisible(false);
                    setQuery("");
                }
            }
        };

        window.addEventListener("keydown", handler);
        return () => window.removeEventListener("keydown", handler);
        // eslint-disable-next-line
    }, [visible, results, activeIndex, navigate]);
    useEffect(() => {
        if (itemRefs.current[activeIndex]) {
            itemRefs.current[activeIndex]?.scrollIntoView({
                block: "nearest",
                behavior: "smooth", // optional smooth scroll
            });
        }
    }, [activeIndex]);

    useEffect(() => {
        itemRefs.current = [];
    }, [results]);

    const onSelect = (item: any) => {
        navigate(item.to);
        setVisible(false);
        setQuery("");
    };

    return (
        <Dialog
            visible={visible}
            onHide={() => setVisible(false)}
            header="Search Menu"
            style={{ width: "500px" }}
            modal
            draggable={false}
            closable
        >
            <span className="p-input-icon-left w-full mb-3">
                <i className="pi pi-search" />
                <InputText
                    autoFocus
                    value={query}
                    onChange={(e) => {
                        setQuery(e.target.value);
                        setActiveIndex(0);
                    }}
                    placeholder="Search menu..."
                    className="w-full mt-1"
                />
            </span>

            <div style={{ maxHeight: "300px", overflowY: "auto" }}>
                {results.length === 0 && (
                    <div className="p-3 text-center text-gray-500">
                        No results found
                    </div>
                )}

                {results.map((item, index) => (
                    <div
                        key={index}
                        ref={(el) => (itemRefs.current[index] = el)}
                        onClick={() => onSelect(item)}
                        className={`p-3 cursor-pointer border-round mb-1 flex align-items-center gap-2 ${
                            index === activeIndex
                                ? "bg-primary text-white"
                                : "hover:bg-gray-100"
                        }`}
                    >
                        {item.icon && <i className={item.icon}></i>}

                        <div>
                            <div className="font-medium">{item.label}</div>
                            {item.parent && (
                                <small className="opacity-70">
                                    {item.parent}
                                </small>
                            )}
                        </div>
                    </div>
                ))}
            </div>
        </Dialog>
    );
};

export default GlobalSearch;